import React, { FC, useCallback, useEffect, useState } from 'react';
import { withUserType } from '../withUserType';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { getPrimaryColor } from '../../utils/DataAccessUtils';

const NewNoteDisplay: FC<any> = ({ onRefresh, newNoteCount, userType }): React.ReactElement => {
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!newNoteCount) setLoading(false);
	}, [newNoteCount]);

	const onNewMessageClick = useCallback(() => {
		setLoading(true);
		onRefresh();
	}, [onRefresh]);

	return newNoteCount > 0 ? (
		<div
			className="bodymedium mx-auto box-border flex w-1/3 cursor-pointer items-center justify-between self-center rounded-3xl rounded-b-none border-2 border-b-0 border-solid border-[#B4B4B4] bg-[#F9F0FF] px-4 py-2 text-[#54298D]"
			style={{
				color: getPrimaryColor(userType),
				backgroundColor: `color-mix(in srgb, ${getPrimaryColor(userType)} 10%, white)`,
			}}
			onClick={onNewMessageClick}
		>
			<div>{`${newNoteCount} new message${newNoteCount > 1 ? 's' : ''}`}</div>
			{loading ? (
				<Spin indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} />
			) : (
				<i
					style={{ fontSize: 16, color: getPrimaryColor(userType) }}
					className={`icons8-down-arrow-filled`}
				/>
			)}
		</div>
	) : null;
};

export default withUserType(NewNoteDisplay) as any;
